module.exports = __webpack_public_path__ + "static/media/Schiratti1931.5624eb65.jpg";